// Hooks for scheduling emailed PDF exports of a multi-dataset report.
// Mirrors use-scheduled-emails.js against the `report_scheduled_emails` routes.
import { useContext } from 'react'
import { useMutation, useQuery } from 'react-query'
import { apiPost, apiGet, apiDelete, apiPatch } from 'api'
import AuthContext from 'context/auth-context'

const createReportScheduledEmail = async (token, reportId, params) => {
  const objectName = 'scheduled_email'
  const url = `reports/${reportId}/report_scheduled_emails`
  const response = await apiPost({ url, token, objectName, params })
  return response
}

export function useCreateReportScheduledEmail({ reportId, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    (params) => createReportScheduledEmail(token, reportId, params),
    { ...options }
  )
}

const getReportScheduledEmails = async (token, reportId, params) => {
  const url = `reports/${reportId}/report_scheduled_emails`
  const data = await apiGet({ url, token, params })
  return data
}

export function useReportScheduledEmails({ reportId, params, options }) {
  const token = useContext(AuthContext)
  const queryFn = () => getReportScheduledEmails(token, reportId, params)
  const queryKey = ['reportScheduledEmails', reportId, params]
  return useQuery(queryKey, queryFn, { ...options })
}

const cancelReportScheduledEmail = async (token, id) => {
  const url = `report_scheduled_emails/${id}`
  const response = await apiDelete({ url, token })
  return response
}

export function useCancelReportScheduledEmail({ id, options }) {
  const token = useContext(AuthContext)
  return useMutation(() => cancelReportScheduledEmail(token, id), { ...options })
}

const updateReportScheduledEmail = async (token, id, params) => {
  const objectName = 'scheduled_email'
  const url = `report_scheduled_emails/${id}`
  const response = await apiPatch({ url, token, objectName, params })
  return response
}

export function useUpdateReportScheduledEmail({ id, options }) {
  const token = useContext(AuthContext)
  return useMutation((params) => updateReportScheduledEmail(token, id, params), { ...options })
}
